"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.COMPONENT_IDENTIFIER = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _card = require("../../../../../card");
var _collapse = require("../../../../../collapse");
var _formulaBody = _interopRequireDefault(require("../formulaBody"));
var _ExcessFormula = _interopRequireDefault(require("./ExcessFormula.style"));
var _ExcessFormulaHeader = _interopRequireDefault(require("./ExcessFormulaHeader"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var COMPONENT_IDENTIFIER = 'excessFormula';
exports.COMPONENT_IDENTIFIER = COMPONENT_IDENTIFIER;
var ExcessFormula = function ExcessFormula(props) {
  var disabled = props.disabled,
    errors = props.errors,
    formulaOperators = props.formulaOperators,
    formulaOtherProps = props.formulaOtherProps,
    getFormulaOperandValues = props.getFormulaOperandValues,
    labels = props.labels,
    rule = props.rule,
    ruleChange = props.ruleChange,
    ruleIndex = props.ruleIndex;
  var canExceed = R.prop('canExceedBudget', rule);
  var excessFormulaExists = canExceed && R.prop(COMPONENT_IDENTIFIER, rule);
  return /*#__PURE__*/_react["default"].createElement(_collapse.Collapse, {
    openItems: excessFormulaExists ? [0] : []
  }, function (_ref) {
    var toggle = _ref.toggle,
      openItems = _ref.openItems;
    var isExpanded = openItems.includes(0);
    return /*#__PURE__*/_react["default"].createElement(_ExcessFormula["default"], {
      isOpen: isExpanded,
      "data-testid": "excess-formula"
    }, /*#__PURE__*/_react["default"].createElement(_card.ControlCard, {
      id: "excess-control-card",
      className: "excess-control-card",
      title: /*#__PURE__*/_react["default"].createElement(_ExcessFormulaHeader["default"], {
        canExceed: canExceed,
        labels: labels,
        ruleChange: ruleChange,
        toggle: toggle,
        isExpanded: isExpanded,
        disabled: disabled,
        COMPONENT_IDENTIFIER: COMPONENT_IDENTIFIER
      }),
      checked: canExceed,
      onChange: function onChange(_, checked) {
        ruleChange('canExceedBudget', checked);
        if (isExpanded) {
          toggle(0);
        }
      },
      disabled: disabled
    }, isExpanded && /*#__PURE__*/_react["default"].createElement(_formulaBody["default"], {
      componentIdentifier: COMPONENT_IDENTIFIER,
      rule: rule,
      labels: labels,
      errors: errors,
      formulaOperators: formulaOperators,
      disabled: disabled,
      ruleChange: ruleChange,
      ruleIndex: ruleIndex,
      getFormulaOperandValues: getFormulaOperandValues,
      formulaOtherProps: formulaOtherProps
    })));
  });
};
ExcessFormula.defaultProps = {
  errors: {},
  disabled: false,
  formulaOtherProps: {},
  formulaOperators: []
};
ExcessFormula.propTypes = {
  disabled: _propTypes["default"].bool,
  rule: _propTypes["default"].shape({}).isRequired,
  ruleChange: _propTypes["default"].func.isRequired,
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  ruleIndex: _propTypes["default"].number.isRequired,
  errors: _propTypes["default"].shape({}),
  formulaOperators: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    displayName: _propTypes["default"].string,
    name: _propTypes["default"].string
  })),
  formulaOtherProps: _propTypes["default"].shape({}),
  getFormulaOperandValues: _propTypes["default"].func.isRequired
};
ExcessFormula.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ExcessFormula",
  "props": {
    "errors": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "formulaOtherProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "formulaOperators": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "displayName": {
              "name": "string",
              "required": false
            },
            "name": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false
    },
    "rule": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    },
    "ruleChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "labels": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": true
    },
    "ruleIndex": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "getFormulaOperandValues": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};
var _default = ExcessFormula;
exports["default"] = _default;